import { render, staticRenderFns } from "./ContentFavorite.vue?vue&type=template&id=79256766&scoped=true&"
import script from "./ContentFavorite.vue?vue&type=script&lang=js&"
export * from "./ContentFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79256766",
  null
  
)

export default component.exports